import { render, staticRenderFns } from "./SRadioButton.vue?vue&type=template&id=69e079d8&scoped=true"
import script from "./SRadioButton.ts?vue&type=script&lang=ts&external"
export * from "./SRadioButton.ts?vue&type=script&lang=ts&external"
import style0 from "./SRadioButton.scss?vue&type=style&index=0&id=69e079d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e079d8",
  null
  
)

export default component.exports